// extracted by mini-css-extract-plugin
export default {"buttonContainer":"kt7X2d","button":"t8Osys","commentButtonIcon":"zN557a","commentButtonContent":"fmMfhx","followButtonContent":"H9gjnT","container":"FiLWWP"};